/* prettier-ignore */

import { Component, computed, HostListener, inject, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { RestService } from 'src/app/services/rest.service';
import { ToolsService } from '../../services/tools.service';
import { crossSiteUrl } from '../../helpers/tech-mode-entry';
import { NavigationService } from 'src/app/services/navigation.service';
import { NewCustomRouteService } from 'src/app/pages/new-custom-route/new-custom-route.service';
import { CookieService } from 'ngx-cookie-service';
import { AuthService } from '../../auth/services';
import { UserService } from 'src/app/user/services';
import { BreakpointsService } from 'src/app/services/breakpoints.service';
import { GamificationService } from 'src/app/shared/gamification/services/gamification.service';
import { OfflineDetectionService, TranslationService } from 'src/app/services';
import { shouldHideBackButtonOffline, shouldHideLogoOffline, shouldShowBackButton, shouldShowBackToDistributor } from './helpers/header.helpers';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    encapsulation: ViewEncapsulation.None,
})

export class HeaderComponent {
    private _translationService = inject(TranslationService)
    private cookieService = inject(CookieService)
    private routeService = inject(NewCustomRouteService);
    public breakpointsService = inject(BreakpointsService);
    private _gamificationService = inject(GamificationService);
    private _offlineDetectionService = inject(OfflineDetectionService);

    public isOnline = this._offlineDetectionService.isOnline;
    public disableTouch = computed(() => this.routeService.disableTouch());
    public isInfoRoutePage = computed(() => this.tools.isInfoRoutePage());
    public languages = this._translationService.languages;
    public isWebApp = computed(() => this.tools.isWebApp());
    public passportEnabled = computed(() => this._gamificationService.passportsEnabled());
    public showGoogleLangs = this._translationService.showGoogleLangs;

    public logo: any;

    @HostListener('document:click', ['$event'])
    hideModalOnClick(event: MouseEvent) {
        if (!this.tools.menuIsShown) return;
        this.tools.menuIsShown = false;
    }
  
    constructor(
        private router: Router, 
        public rest: RestService, 
        public tools: ToolsService, 
        private userService: UserService,
        private authService: AuthService,
        public navigation: NavigationService
    ) {
        this.logo = this.rest.device()?.logo?.value;
    }

    goToHome(){
      const currentUrl = this.router.url;
      if (currentUrl.includes('custom-route')){
        this.tools.goBack();
        return;
      }
      
      if (this.tools.isTechEditMode() || this.tools.isRegisterMode() || this.isInfoRoutePage()) return;
        
      this.router.navigateByUrl('/home');
    }

    goBack(){
        const currentUrl = this.router.url;
        if (currentUrl.includes('custom-route')){
            this.tools.goBack();
            return;
        }

        if(this.isBackDistributor()){
            this.goDistributor();
            return;
        }

        if (currentUrl.includes('not-found'))
            this.navigation.resetNavigation();
    
        this.navigation.goBack();
    }

    goDistributor(){
        if (this.tools.isPreProduction()){
            const splitUrl = this.tools.homeDistributor?.split('.');
            const splitHttp = splitUrl?.[0].split('//');
            const nameIndex = splitHttp?.[splitHttp?.length - 1]?.trim();
            this.cookieService.set('preProduction', nameIndex)
            window.location.assign(crossSiteUrl(window.location.origin, this.tools.informerMode()))
            return;
        }
        // HRS-3145: el modo del informador vive en el localStorage de este
        // subdominio; el prefijo /tech-mode/ lo lleva al portal.
        window.location.assign(crossSiteUrl(this.tools.homeDistributor, this.tools.informerMode()));
    }

    showBackButton(){
        return shouldShowBackButton(this.router.url, this.tools.isTechEditMode())
    }

    hideLogoOffline(){
        return shouldHideLogoOffline(this.router.url, this.isOnline())
    }

    hideBackButtonOffline(){
        return shouldHideBackButtonOffline(this.router.url, this.isOnline())
    }

    isBackDistributor(){
        return shouldShowBackToDistributor(this.router.url, this.tools.homeDistributor)
    }

    handlePassportClick(){
        if (!this.authService.user()){
            this.userService.login();
            return;
        }

        this.router.navigateByUrl('/my-account/passports')
    }

}